import watermark from '../utils/watermark-dom'
import { mapGetters } from 'vuex'
import { debounce } from '@/components/CommonLayout/utils'
import ResizeObserver from 'resize-observer-polyfill'

export default {
  data() {
    return {
      watermarkFont: 16,
      watermarkWidth: 0,
      observer: null,
      recordOldValue: {},
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'tenantName']),
    waterMarkTxt() {
      const tenantName = this.tenantName ? `${this.tenantName}服务平台` : ''
      const userName = this.userInfo.userName ? `${this.userInfo.userName}-` : ''
      const userAccount = this.userInfo.userAccount || ''
      return `${tenantName}<br />${userName}${userAccount}`
    },
    waterMarkOption() {
      const op = {
        watermark_id: 'wm_div_id',
        watermark_x: 10, // 水印起始位置x轴坐标
        watermark_y: 10, // 水印起始位置Y轴坐标
        watermark_rows: 0, // 水印行数
        watermark_cols: 0, // 水印列数
        watermark_x_space: 50, // 水印x轴间隔
        watermark_y_space: 30, // 水印y轴间隔
        watermark_font: '微软雅黑', // 水印字体
        watermark_color: '#313641', // 水印字体颜色
        watermark_fontsize: `${this.watermarkFont} px`, // 水印字体大小
        watermark_alpha: 0.1, // 水印透明度，要求设置在大于等于0.005
        watermark_width: this.watermarkWidth, // 水印宽度
        watermark_height: 80, // 水印长度
        watermark_angle: 20, // 水印倾斜度数
        watermark_parent_node: 'watermark-container',
      }
      return op
    },
  },
  watch: {
    tenantName: {
      handler(to, from) {
        if (to !== from) {
          this.loadWatermark()
        }
      },
      immediate: true,
    },
    'userInfo.userName': {
      handler(to, from) {
        if (to !== from) {
          this.loadWatermark()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.appMainResizeObserver()
  },
  beforeDestroyed() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    listenAppMain() {
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
      const option = {
        childList: true, // 子节点的变动（新增、删除或者更改）
        attributes: true, // 属性的变动
        characterData: true, // 节点内容或节点文本的变动
        subtree: true, // 是否将观察器应用于该节点的所有后代节点
        attributeFilter: ['class', 'style'], // 观察特定属性
        attributeOldValue: false, // 观察 attributes 变动时，是否需要记录变动前的属性值
        characterDataOldValue: false, // 观察 characterData 变动，是否需要记录变动前的值
      }
      this.observer = new MutationObserver(() => {
        const appMain = document.getElementById('watermark-container')
        const appMainWidth = appMain.scrollWidth
        const appMainHeight = appMain.scrollHeight
        if (appMainWidth === this.recordOldValue.width && appMainHeight === this.recordOldValue.height) return
        this.recordOldValue = {
          width: appMainWidth,
          height: appMainHeight,
        }
        console.log(appMain.scrollWidth)
        console.log(appMain.scrollHeight)
        this.loadWatermark()
      }).observe(document.getElementById('watermark-container'), option)
    },
    loadWatermark: debounce(function () {
      const tenantName = this.tenantName ? `${this.tenantName}服务平台` : ''
      const userName = this.userInfo.userName ? `${this.userInfo.userName}-` : ''
      const userAccount = this.userInfo.userAccount || ''
      const txtTop = `${tenantName}`
      const txtBottom = `${userName}${userAccount}`
      this.watermarkWidth = this.countTxtWidth(txtTop, txtBottom)
      // console.log('watermarkWidth====', this.watermarkWidth)
      this.handlerWatermark()
    }, 500),
    handlerWatermark() {
      // console.log('reloadwatermarkWidth====', this.watermarkWidth)
      watermark.load({
        ...this.waterMarkOption,
        watermark_txt: this.waterMarkTxt, // 水印的内容
      })
    },
    countTxtWidth(txtTop, txtBottom) {
      let txtTopWidth = 0
      let txtBottomWidth = 0
      const txtTopSpan = document.createElement('span')
      const txtBottomSpan = document.createElement('span')
      txtTopSpan.style.fontSize = `${this.watermarkFont}px`
      txtTopSpan.style.visibility = 'hidden'
      txtTopSpan.style.whiteSpace = 'nowrap'
      txtTopSpan.innerHTML = txtTop
      txtBottomSpan.style.fontSize = `${this.watermarkFont}px`
      txtBottomSpan.style.visibility = 'hidden'
      txtBottomSpan.style.whiteSpace = 'nowrap'
      txtBottomSpan.innerHTML = txtBottom
      document.body.append(txtTopSpan)
      document.body.append(txtBottomSpan)
      txtTopWidth = txtTopSpan.offsetWidth
      txtBottomWidth = txtBottomSpan.offsetWidth
      document.body.removeChild(txtTopSpan)
      document.body.removeChild(txtBottomSpan)
      return txtTopWidth > txtBottomWidth ? txtTopWidth : txtBottomWidth
    },
    appMainResizeObserver() {
      this.observe = new ResizeObserver(() => {
        // console.log(document.getElementById('watermark-container').offsetWidth)
        this.loadWatermark()
      }).observe(document.getElementById('watermark-container'))
    },
  },
}
